import { IntegrationWorkflowInputType } from '@kindo/universal';

import { getIntegrationInputFieldDisplayName } from '../WorkflowIntegrationInput.utils';

import { Table, TableColumn, TableRow, TextIconColor } from '~/components/core';

interface IntegrationInputFieldSelectorProps<InputField extends string> {
  integrationInputFields: InputField[];
  integrationInputType: IntegrationWorkflowInputType | null;
  selectedInputFields: InputField[];
  setSelectedInputFields: (selected: InputField[]) => void;
}

const IntegrationInputFieldSelector = <InputField extends string>({
  integrationInputFields,
  integrationInputType,
  selectedInputFields,
  setSelectedInputFields
}: IntegrationInputFieldSelectorProps<InputField>) => {
  const columns: TableColumn<string>[] = [
    {
      title: ''
    }
  ];
  const rows: TableRow<InputField>[] = integrationInputFields.map((row) => ({
    key: row,
    height: 'h-11',
    textColor: TextIconColor.PRIMARY,
    cells: integrationInputType
      ? [getIntegrationInputFieldDisplayName(integrationInputType, row)]
      : []
  }));
  return (
    <div
      className="bg-primary-panel flex max-h-60 w-full overflow-y-auto rounded-md drop-shadow-sm"
      data-testid="integration-input-field-selector-container"
    >
      <Table<InputField>
        columns={columns}
        noRowsText=""
        rows={rows}
        selectionProps={{
          selectedItems: selectedInputFields.map((val) => val),
          setSelectedItems: setSelectedInputFields
        }}
        showHeader={false}
      />
    </div>
  );
};

export default IntegrationInputFieldSelector;
